/* eslint-disable react-hooks/exhaustive-deps */
import { React, useEffect, useContext } from "react";
import axios from "axios";
import "./Dashboard.css";
import {
  Link  
} from "react-router-dom";
import { VideoContext } from "../Helper/Context";
import config from '../config.json'


// function which shows the date between two dates
const days = function (date1, date2) {
  let dt1 = new Date(date1);
  let dt2 = new Date(date2);
  return Math.floor(
    (Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) -
      Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) /
      (1000 * 60 * 60 * 24)
  );
};

const EachVideoTile = ({ imgLink, videoId, title, time, viewCount }) => {
 
  return (
    <Link to={`/videos/${videoId}`}  className="video-tile-link">
      <div className="video-tile">
        <div className="image-container">
          <img
            src={imgLink}
            alt="video Preview"
            style={{ height: "118px", width: "210px" }}
          />
        </div>

        <div className="video-info">
          <div className="semi-bold show-max-two-lines">{title}</div>
          <div className="video-preview-metadata-container">
            <div>
              <span>
                {viewCount} • {`${days(new Date(), time)} Days ago`}
              </span>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

function DashBoard() {
  const myVideos = useContext(VideoContext);
 
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(async () => {
    const res = await axios
      .get(
        `${config.endpoint}/videos`
       
      )
      .then((res) => {
        // myVideos.setResult(res.data.videos);
        return res;
      })
      .catch((err) => console.log(err));

    if (res) {
      myVideos.setResult(res.data.videos);
      myVideos.setVideo(res.data.videos);
    }
    myVideos.setChange(false);
  }, [myVideos.change]);

  return (
    <div className="grid">
      {myVideos.video.map((val, idx) => {
        return (
          <EachVideoTile
            key={idx}
            className="item"
            imgLink={val.previewImage}
            time={val.releaseDate}
            videoId={val._id}
            title={val.title}
            viewCount={val.viewCount}
            
          />
        );
      })}
    </div>
  );
}

export { DashBoard, EachVideoTile };
